import {Loader} from "@googlemaps/js-api-loader";

document.addEventListener("DOMContentLoaded", () => {
    let map = document.querySelector(".js-map");
    if (map !== null) {
        let lat = map.getAttribute("data-lat");
        let lng = map.getAttribute("data-lng");
        let zoom = map.getAttribute("data-zoom");
        let title = map.getAttribute("data-title");
        let content = map.getAttribute("data-content");
        let key = map.getAttribute("data-key");

        loadMap(map, {
            lat: lat,
            lng: lng,
            zoom: zoom,
            title: title,
            content: content,
            key: key,
        });
    }
});

let loadMap = async (mapElement, data) => {
    let mapLoader = new Loader({
        apiKey: data.key,
        version: "weekly",
    });
    const {Map, InfoWindow} = await mapLoader.importLibrary("maps");

    let map = new Map(mapElement, {
        zoom: parseInt(data.zoom),
        center: {lat: parseFloat(data.lat), lng: parseFloat(data.lng)},
        mapId: "contact_map",
    });

    let cont = document.createElement("div");
    cont.innerHTML = data.content;

    const {AdvancedMarkerElement} = await mapLoader.importLibrary("marker");
    let infoWindow = new InfoWindow({
        content: cont,
        disableAutoPan: true,
    });

    let marker = new AdvancedMarkerElement({
        map: map,
        position: {lat: parseFloat(data.lat), lng: parseFloat(data.lng)},
        title: data.title,
    });

    marker.addListener("click", () => {
        infoWindow.open(map, marker);
    });
};
